module.exports = __webpack_public_path__ + "img/guahaoRecord.53a6b6af.png";